<template>
	<div class="checkout">
		<b-row>
			<b-col
			cols="12"
			lg="11"
			xl="10"
			offset-lg="0"
			offset-xl="1">

				<div class="checkout__header">
					<h1 class="checkout__title">
						Confirmá tu pedido
					</h1>
					<p class="checkout__subtitle">
						Revisá los datos y elegí cómo lo recibís y cómo lo pagás.
					</p>
				</div>

				<b-row>
					<b-col
					cols="12"
					lg="7">

						<whats-app-info></whats-app-info>

						<deliver></deliver>

						<!--
							El formulario de identificación es solo para el comprador que compra sin
							registrarse. Hasta el 7/9/2026 acá había un `v-if/v-else` más un
							`v-if` suelto que, con una tienda que permite comprar sin registro y un
							comprador YA logueado, montaba el bloque de entrega DOS veces.
						-->
						<buyer
						v-if="comprador_invitado"></buyer>

						<seller-select-client></seller-select-client>

						<!--
							Dirección de entrega. Con las direcciones de envío nuevas (19/10/2026,
							`commerce.direcciones_de_envio`) es el bloque con el buscador de Google y la
							lista de direcciones del comprador, ANTES de las formas de envío (con la
							dirección se cotiza el correo). Sin eso, el input de texto libre de siempre.
						-->
						<direccion-de-entrega
						v-if="direcciones_de_envio_activas"></direccion-de-entrega>

						<addresses
						v-else></addresses>

						<!--
							Formas de envio en una sola lista (zonas del negocio + correo por Zipnova)
							y, si eligio correo, el formulario completo del destino. Reemplazan a
							<delivery-zones> desde el 14/9/2026 (el archivo queda, sin montar).
						-->
						<formas-de-envio></formas-de-envio>

						<direccion-envio></direccion-envio>

						<delivery-day></delivery-day>

						<!--
							Hasta el 14/10/2026 aca iba el bloque "¿Tenés un cupón?". Se saco con los
							cupones de la tienda (mision tiendas-demo-y-limpieza-tienda).
						-->
						<payment-method></payment-method>

						<description></description>

					</b-col>

					<b-col
					cols="12"
					lg="5">
						<cart-resume></cart-resume>
					</b-col>
				</b-row>

			</b-col>
		</b-row>
	</div>
</template>
<script>
import Deliver from '@/components/payment/components/Deliver'
import PaymentMethod from '@/components/payment/components/payment-method/Index'
import Addresses from '@/components/payment/components/Addresses'
import FormasDeEnvio from '@/components/payment/components/FormasDeEnvio'
import DireccionEnvio from '@/components/payment/components/DireccionEnvio'
import Description from '@/components/payment/components/Description'
import DireccionDeEntrega from '@/components/payment/components/DireccionDeEntrega'
import { trackear, TIPOS_EVENTO } from '@/utils/tracking'
import { direcciones_activas } from '@/helpers/direcciones'
export default {
	components: {
		WhatsAppInfo: () => import('@/components/payment/components/WhatsAppInfo'),
		CartResume: () => import('@/components/payment/components/CartResume'),
		SellerSelectClient: () => import('@/components/payment/components/SellerSelectClient'),
		Buyer: () => import('@/components/payment/components/Buyer'),
		DeliveryDay: () => import('@/components/payment/components/DeliveryDay'),
		Deliver,
		PaymentMethod,
		Addresses,
		FormasDeEnvio,
		DireccionEnvio,
		Description,
		DireccionDeEntrega,
	},
	created() {
		this.setTitle('Pedido')
		this.$store.commit('cart/setPaymentMethod', null)
		/* El comprador entró a confirmar la compra. El par con checkout_complete es lo que
		   deja medir el abandono del checkout. */
		trackear(TIPOS_EVENTO.CHECKOUT_INICIO)
	},
	computed: {
		/**
		 * Comprador que está comprando sin cuenta, en una tienda que lo permite: es el único que
		 * ve el formulario de identificación del checkout.
		 *
		 * @returns {boolean}
		 */
		comprador_invitado() {
			return !this.flag_activo(this.commerce.online_configuration.register_to_buy) && !this.authenticated
		},
		cart_buyer() {
			return this.$store.state.cart.buyer
		},
		/**
		 * Si la tienda tiene las direcciones de envío nuevas. Ver `direcciones_activas` en
		 * helpers/direcciones.js.
		 *
		 * @returns {boolean}
		 */
		direcciones_de_envio_activas() {
			return direcciones_activas(this.commerce)
		},
	},
}
</script>
